import { render } from "./CreateSurvey.vue?vue&type=template&id=4c6b43e0&scoped=true"
import script from "./CreateSurvey.vue?vue&type=script&lang=ts"
export * from "./CreateSurvey.vue?vue&type=script&lang=ts"

import "./CreateSurvey.vue?vue&type=style&index=0&id=4c6b43e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c6b43e0"

export default script